/* Скрипт получения установок для конкретных режимов игры */

export default {
    install(Vue, options) {
        Vue.prototype.$ModComponents = function (id,setting) {
            // 0 - не показывать 1 - показ на всех экранах 2 - показ только на больших экранах 3 - показ только на маленьких
            const components = [
                {
                    type: 'none',
                    authors: [],
                    title: '',
                    text: '',
                    image: 'none',
                },
                {
                    type: 'gameMode',
                    authors: ['firsacho'],
                    title: '[BB] Bridge Build',
                    text: 'BB',
                    image: 'BridgeBuild',
                }, 
                {
                    type: 'gameMode',
                    authors: ['firsacho'],
                    title: '[BOX]',
                    text: '',
                    image: 'none',
                },
                {
                    type: 'gameMode',
                    authors: ['Profile','firsacho'],
                    title: '[GG] Gun Game',
                    text: '',
                    image: 'none',
                },
                {
                    type: 'gameMode',
                    authors: ['firsacho'],
                    title: '[PRO] PRO MODE',
                    text: '',
                    image: 'none',
                },                
                {
                    type: 'gameMode',
                    authors: ['firsacho'],
                    title: '[RR] Rope Race',
                    text: '',
                    image: 'none',
                },              
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] 911',
                    text: '',
                    image: '911',
                }, 
               {
                    type: 'map',
                    authors: [''],
                    title: '[PRO] Blocks 4x4x4',
                    text: '',
                    image: '4x4x4',
                },                
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[BB] Bridge Build',
                    text: '',
                    image: 'BridgeBuild',
                },                 
                {
                    type: 'map',
                    authors: [''],
                    title: '[ND] Battleships',
                    text: '',
                    image: 'dd_battleships',
                },
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Cap Map',
                    text: '',
                    image: 'dm_capmap',
                },                 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Castle in Sky',
                    text: '',
                    image: 'dm_castleinsky',
                }, 
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[CS] Castle Siege',
                    text: '',
                    image: 'cs_castlesiege',
                },                
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[HL] Castles XL',
                    text: '',
                    image: 'homelands1',
                },                
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[DM] Crash Arena',
                    text: '',
                    image: 'CrashArena',
                },                 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Desert Road 2',
                    text: '',
                    image: 'dm_desertroad',
                },                
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Egypt 2',
                    text: '',
                    image: 'dm_egypt',
                }, 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Electronics 2',
                    text: '',
                    image: 'dm_electronics',
                },                                  
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[RR] Empty Walls',
                    text: '',
                    image: 'EmptyWalls',
                },
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Flood Island',
                    text: '',
                    image: 'FloodIsland',
                }, 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Food Table',
                    text: '',
                    image: 'dm_foodtable',
                },                  
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: "[PRO] Forest of Ninja's",
                    text: '',
                    image: 'forest',
                }, 
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[FAF] From a Flood',
                    text: '',
                    image: 'faf1',
                },                  
                {
                    type: 'map',
                    authors: [''],
                    title: '[PRO] Great Sphere',
                    text: '',
                    image: 'dm_greatsphere',
                },                 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Greece 2',
                    text: '',
                    image: 'dm_greece',
                },                 
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[BOX] Headshot',
                    text: '',
                    image: 'headshot',
                },                   
                {
                    type: 'map',
                    authors: ['Profile'],
                    title: '[DM] Insectoid Attack',
                    text: '',
                    image: 'InsectoidAttack',
                },
                {
                    type: 'map',
                    authors: ['Vera34'],
                    title: '[DM] In Water',
                    text: '',
                    image: 'InWater',
                },                 
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[BOX] Jungle',
                    text: '',
                    image: 'jungle',
                },
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Jungle Temple',
                    text: '',
                    image: 'JungleTemple',
                }, 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Playground',
                    text: '',
                    image: 'dm_playground',
                },                
                {
                    type: 'map',
                    authors: [''],
                    title: '[PRO] Poxel Art',
                    text: '',
                    image: 'dm_poxelart',
                },
                {
                    type: 'map',
                    authors: [''],
                    title: '[PRO] Promap',
                    text: '',
                    image: 'promap',
                },                 
                {
                    type: 'map',
                    authors: [''],
                    title: '[BOX] Room',
                    text: '',
                    image: 'Room',
                },                 
                {
                    type: 'map',
                    authors: ['firsacho'],
                    title: '[RR] Save the princess!',
                    text: '',
                    image: 'rr_mario',
                }, 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Secret Station 2',
                    text: '',
                    image: 'dm_secretstation',
                },
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Secret Station 2',
                    text: '',
                    image: 'dm_secretstation',
                },                
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Street',
                    text: '',
                    image: 'dm_street',
                },  
                {
                    type: 'map',
                    authors: ['Nezon'],
                    title: '[PRO] Underwater World',
                    text: '',
                    image: 'dm_underwaterworld',
                },                 
                {
                    type: 'map',
                    authors: ['Nezon'],
                    title: '[DM] Victory Or Death',
                    text: '',
                    image: 'VictoryOrDeath',
                },                 
                {
                    type: 'map',
                    authors: [''],
                    title: '[DM] Worm City',
                    text: '',
                    image: 'WormCity',
                }, 
                {
                    type: 'map',
                    authors: ['Nezon'],
                    title: '[DM] Ziggurat',
                    text: '',
                    image: 'Ziggurat',
                }, 
                
                {
                    type: 'mission',
                    authors: ['firsacho'],
                    title: '[RR] Empty Walls',
                    text: 'EmptyWalls',
                    image: 'EmptyWalls',
                },
                {
                    type: 'mission',
                    authors: ['firsacho'],
                    title: '[FAF] From a Flood',
                    text: '',
                    image: 'faf1',
                },                 
                {
                    type: 'mission',
                    authors: ['firsacho'],
                    title: '[RR] Save the princess!',
                    text: 'rr_mario',
                    image: 'rr_mario',
                },                
            ]
            if(components[id] == undefined) return components[0][setting]
            if(components[id][setting] != undefined)return components[id][setting]
            else if (components[id][setting] == undefined)return components[0][setting]            
            return components[id][setting]
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/modDB.js